import React from "react";
import IconSvg from "./IconSvg";
import "./style.css";

const CEEPerformanceSection = ({ data }) => {
  const { roleReadinessMetrics, insight } = data;

  // Map colors from JSON to Tailwind classes
  const colorClassMap = {
    "bg-success-500": "text-success-600",
    "bg-warning-500": "text-warning-600",
    "bg-custom-blue": "text-custom-blue", // Direct hex color
    "bg-danger-500": "text-danger-600",
  };
  const length = roleReadinessMetrics.length;
  const key_insights = 100 - roleReadinessMetrics[length - 1].percentage;
  return (
    <section className="mb-6">
      <h2 className="section-heading">
        <IconSvg
          path="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
          className="h-5 w-5 mr-2 text-primary-600"
        />
        CEE Performance Metrics
        <div className="tooltip-wrapper">
          <IconSvg
            path="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            className="h-4 w-4 text-gray-400"
          />
          <div className="tooltip-content w-64">
            Key performance indicators from the CareerCarve Employability
            Examination (CEE).
          </div>
        </div>
      </h2>
      <div className="grid grid-cols-1 gap-4">
        {/* Role Readiness Metrics Card */}
        <div className="card p-4">
          <div className="flex justify-between items-start mb-3">
            <span className="font-medium text-gray-800">
              Role Readiness Metrics
            </span>
            <div className="tooltip-wrapper">
              <IconSvg
                path="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                className="tooltip-icon"
              />
              <div className="tooltip-content w-48">
                Assessment of how prepared students are for specific job roles
                with varying degrees of fit.
              </div>
            </div>
          </div>

          <div className="role-readiness-grid">
            {roleReadinessMetrics.map((metric) => (
              <div key={metric.label} className="role-readiness-item">
                <div className="role-readiness-dot-wrapper">
                  <div className={`role-readiness-dot ${metric.color}`}></div>
                  <span className="role-readiness-label">{metric.label}</span>
                </div>
                <div className="flex flex-col">
                  <span
                    className={`text-xl font-semibold ${
                      colorClassMap[metric.color] || "text-gray-900"
                    }`}
                  >
                    {metric.percentage}%
                  </span>
                  <span className="role-readiness-description">
                    {metric.description}
                  </span>
                </div>
              </div>
            ))}
          </div>

          <div className="border-t border-gray-100">
            <span className="text-sm text-gray-600">
              <span className="font-medium text-indigo-600">Key insight:</span>{" "}
              {key_insights.toFixed(2)}% of students have at least one viable
              career path or role fit.
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CEEPerformanceSection;
